import { useMemo, useCallback, useState, FC } from 'react';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { Icon, tailwindOverride } from '@getsynapse/design-system';
import { ProjectTasksViews } from 'utils/constants/projectTasks';
import TableViewIcon from 'assets/icons/table_view_icon.svg';
import GanttViewIcon from 'assets/icons/gantt_view_icon.svg';
import ToggleButtonGroup from 'Molecules/ToggleButtonGroup/ToggleButtonGroup';

interface ViewSwitcherProps {
  projectId: string;
}

const ViewSwitcher: FC<ViewSwitcherProps> = ({ projectId }) => {
  const [selectedView, setSelectedView] = useState<ProjectTasksViews>(
    ProjectTasksViews.TABLE
  );
  const { projectTasksGanttView = false } = useFlags();

  const viewOptions = useMemo(() => {
    return [
      {
        children: (isSelected: boolean) => (
          <Icon
            src={TableViewIcon}
            className={tailwindOverride('h-4 fill-neutral-dark', {
              'fill-neutral-white': isSelected,
            })}
          />
        ),
        key: ProjectTasksViews.TABLE,
      },
      {
        children: (isSelected: boolean) => (
          <Icon
            src={GanttViewIcon}
            className={tailwindOverride('h-4 fill-neutral-dark', {
              'fill-neutral-white': isSelected,
            })}
          />
        ),
        key: ProjectTasksViews.GANTT,
      },
    ];
  }, []);

  const handleToggleViewMode = useCallback(
    (key: string) => {
      setSelectedView(key as ProjectTasksViews);
      if (key === ProjectTasksViews.GANTT) {
        window.location.href = `/v2/project/${projectId}/tasks`;
      }
    },
    [projectId]
  );

  if (!projectTasksGanttView) {
    return null;
  }

  return (
    <div
      className='absolute top-0 right-0 mr-40 z-5'
      aria-label='View switcher'
    >
      <ToggleButtonGroup
        buttonsList={viewOptions}
        className='gap-x-1'
        onChange={handleToggleViewMode}
        selected={selectedView}
      />
    </div>
  );
};

export default ViewSwitcher;
